import { getEmptyOrder } from '@/store/module-data-func.js';

export const state = {
  configuration: {
    businessId: null,
    urlToPayService: null,
    maxVisitDateDays: null,
    refillPageUrl: null,
    backUrl: null,
    mainUrl: null,
    cardNum: null,
    posId: null,
    t2PPosId: null,
    payByClubCard: false,
    payBySpb: false,
    payClubCard: false,
    payClubCardBonus: false,
    paySbp: true,
    viewMode: 'Standard',
    directoryMode: 'Buy',
    locale: 'ru',
    catalogUseT2P: false,
    stubEnabledT2P: false,
    stubTitleT2P: '',
    stubDescriptionT2P: '',
    stubPosIdT2P: '',
    buyQuickT2P: false,
    widgetCard: false,
    feedbackTitle: '',
    websiteFb: null,
    tgLinkFb: null,
    vkLinkFb: null,

    colorButton: '',
    colorText: '',

    tabbarColorButton: '',
    tabbarColorButtonBackground: '',
    tabbarColorText: '',
    tabbarColorTextActive: '',

    logoContainerWidth: '160',
    logoContainerHeight: '48',

    logo: null,
    logo2: null,
    paymentGateway: null,
    images: [],
    imagesVersion: 0
  },

  cardHistory: [],
  cardTarifications: [],
  cardSubscriptions: [],

  order: {
    ...getEmptyOrder()
  },
  cardNum: null,
  phone: null,
  email: null,
  compatFilter: null,
  catalog: [],
  shoppingCart: [],
  visitDate: new Date()
  // appVersion: '?',
  // api2CardsVersion: '?'
};
